var FormationTypes = {
    bts: "BTS",
    cpes: "CPES",
    cpgeCommerce: "CPGE Commerce",
    cpgeEcoDroit: "CPGE Economie - Droit",
    cpgeLitt: "CPGE Litt\xe9raire",
    cpgeSciences: "CPGE Scientifique",
    miseNiveauSciences: "Ann\xe9e de mise \xe0 niveau en sciences",
    comptaGestion: "Dipl\xf4me de Comptabilit\xe9 et Gestion",
    arts: "Ecole d'arts",
    cinema: "Ecole de cin\xe9ma",
    archi: "Ecole d'architecture",
    hotel: "Ecole d'h\xf4tellerie",
    communication: "Ecole de communication",
    journal: "Ecole de journalisme",
    prepaArts: "Classe pr\xe9paratoire en Arts",
    ingePostBac: "Ecole d'ing\xe9nieur post-bac  / pr\xe9pa int\xe9gr\xe9e",
    ingeBacPlus2: "Ecole d'ing\xe9nieurs (apr\xe8s bac+2)",
    commercePostBac: "Ecole de commerce (apr\xe8s bac)",
    commerceBacPlus2: "Ecole de commerce (apr\xe8s bac+2)",
    fonctionPublique: "Ecole de la fonction publique",
    normale: "Ecole Normale Sup\xe9rieure",
    veterinaire: "Ecole v\xe9t\xe9rinaire",
    sciencesPo: "IEP/Sciences Po",
    paraMedicale: "Ecole param\xe9dicale",
    prepaEna: "Pr\xe9p ENA",
    iut: "Universit\xe9 - IUT",
    langues: "Universit\xe9 - Langues",
    sciencesHumaines: "Universit\xe9 - Sciences humaines et sociales",
    medecine: "Universit\xe9 - M\xe9decine",
    sport: "Universit\xe9 - Sport",
    droit: "Universit\xe9 - Droit",
    lettres: "Universit\xe9 - Lettres - sciences du langage - arts",
    sciences: "Universit\xe9 - Sciences",
    ecoGestion: "Universit\xe9 - Economie et gestion",
    licencePro: "Universit\xe9 - Licence professionnelle",
    prepaParaMedicale: "Classe pr\xe9paratoire aux concours param\xe9dicaux",
    etranger: "Formation \xe0 l'\xe9tranger",
    autres: "Autre"
};
export { FormationTypes };
